// extracted by mini-css-extract-plugin
export var borderContainer = "product-variants-module--borderContainer--a4691";
export var bottomImageContainer = "product-variants-module--bottomImageContainer--8f7e3";
export var carouselContainer = "product-variants-module--carouselContainer--32179";
export var ctaLink = "product-variants-module--ctaLink--1eb7b";
export var description = "product-variants-module--description--c75b5";
export var next = "product-variants-module--next--d7dad";
export var prev = "product-variants-module--prev--0d4c8";
export var title = "product-variants-module--title--3dafd";
export var topImageContainer = "product-variants-module--topImageContainer--c9eb5";
export var variant = "product-variants-module--variant--42b71";
export var variantDescription = "product-variants-module--variantDescription--c701e";
export var variantSubheading = "product-variants-module--variantSubheading--5d503";
export var variantTitle = "product-variants-module--variantTitle--e1823";
export var variantsContainer = "product-variants-module--variantsContainer--0c778";
export var wrapper = "product-variants-module--wrapper--9c36c";